import React from 'react';
import 'styles/helpers.css';
import AreaSwitchView from './AreaSwitch.View';
import { useAreaSwitchState } from './AreaSwitch.state';
import AreaSwitchLowerTopBarView from './AreaSwitchLowerTopBar.View';

export interface IAreaSwitchProps {
    color?: string;
    isLowerTopBar?: boolean;
}
const AreaSwitch: React.FC<IAreaSwitchProps> = (props) => {
    const { color, isLowerTopBar } = props;
    const state = useAreaSwitchState(color);

    return isLowerTopBar ? (
        <AreaSwitchLowerTopBarView
            {...{ ...state, ...{ selectedArea: state.currentAreaId, color, options: state.areaOptions, areaGroupOptions: state.areaGroupOptions } }}
        />
    ) : (
        <AreaSwitchView {...{ ...state, ...{ selectedArea: state.currentAreaId, color } }} />
    );
};

export default AreaSwitch;
